import React, { useEffect, useState } from 'react'
import GrillaAdjuntoJuicio from './GrillaAdjuntoJuicio'
import GrillaAdjuntoFactura from './GrillaAdjuntoFactura'
import { Seccion, Spinner } from 'asocomponents'
import GrillaAdjuntos from './GrillaAdjuntos'
import DocumentoService from '../../../../modules/Documentos/application/DocumentoService'

export default function Prueba() {

    const [isLoading, setIsLoading] = useState(false)
    const [adjuntos, setAdjuntos] = useState([])


    const obtenerDocumentos = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService()
        let documentos = await documentosServices.getDocumentosFactura(6)

        setAdjuntos(prev => prev.concat(documentos))
        setIsLoading(false)
    }

    const obtenerDocumentosThuban = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService()

         let documentos = await documentosServices.getDocumentosJuicioS3(85799)
         let documentos2 = await documentosServices.getDocumentosJuicioThuban(82620)
        let documentos3 = await documentosServices.getDocumentosSiniestro("0-622383")

        setAdjuntos(prev => prev.concat(documentos, documentos2, documentos3))

        //setAdjuntos(prev => prev.concat(documentos3))


        setIsLoading(false)
    }


    useEffect(() => {
        obtenerDocumentos()
        obtenerDocumentosThuban()
    }, [])

    return (
        <div>
            <Seccion titulo="DOCUMENTOS DIGITALIZACION REINGENIERIA" />
            <GrillaAdjuntoFactura idFactura={1} />
            <Seccion titulo="DOCUMENTOS THUBAN-PISCYS" />
            <GrillaAdjuntoJuicio idJuicio={222971} />
            <Seccion titulo="DOCUMENTOS DIGITALIZACION THUBAN Y REINGENIERIA" />

            {isLoading ?
                <Spinner color="red" size="50" /> :
                <GrillaAdjuntos adjuntos={adjuntos} />
            }

        </div>
    )
}
